import React, { useState, useEffect } from "react";
import "../../css/Home.css";

const GITHUB_API =
    "https://api.github.com/repos/VuongMinh01/MinMedia-anh/contents/Home";

const IMAGE_EXTENSIONS = /\.(jpe?g|png|webp|avif|gif)$/i;

export default function Home() {
    const [images, setImages] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    // Tự động lấy toàn bộ ảnh từ GitHub
    useEffect(() => {
        const controller = new AbortController();

        async function fetchImages() {
            try {
                const response = await fetch(GITHUB_API, {
                    signal: controller.signal,
                });

                if (!response.ok) {
                    throw new Error("Không thể tải danh sách ảnh");
                }

                const files = await response.json();

                const imageList = files
                    .filter(
                        (file) =>
                            file.type === "file" &&
                            IMAGE_EXTENSIONS.test(file.name) &&
                            file.download_url
                    )
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((file) => ({
                        src: file.download_url,
                        alt: file.name.replace(/\.[^.]+$/, ""),
                        name: file.name,
                    }));

                setImages(imageList);
                setError(imageList.length === 0);
            } catch (err) {
                if (err.name !== "AbortError") {
                    console.error("Lỗi tải ảnh:", err);
                    setError(true);
                }
            } finally {
                if (!controller.signal.aborted) {
                    setLoading(false);
                }
            }
        }

        fetchImages();

        return () => controller.abort();
    }, []);

    // Tự động chuyển ảnh mỗi 5 giây
    useEffect(() => {
        if (images.length < 2) return;

        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % images.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [images.length]);

    const nextSlide = () => {
        setCurrentIndex((prev) => (prev + 1) % images.length);
    };

    const prevSlide = () => {
        setCurrentIndex(
            (prev) => (prev - 1 + images.length) % images.length
        );
    };

    if (loading) {
        return <div className="home">Đang tải hình ảnh...</div>;
    }

    if (error) {
        return (
            <div className="home">
                Không tải được ảnh. Hãy kiểm tra repository GitHub.
            </div>
        );
    }

    return (
        <div className="home">
            <div className="slider">
                {images.map((image, index) => (
                    <div
                        key={image.name}
                        className={`slide ${index === currentIndex ? "active" : ""
                            }`}
                        aria-hidden={index !== currentIndex}
                    >
                        <img
                            src={image.src}
                            alt={image.alt}
                            className="slider-image"
                            loading={index === 0 ? "eager" : "lazy"}
                            fetchPriority={index === 0 ? "high" : "auto"}
                            decoding="async"
                        />
                    </div>
                ))}

                {images.length > 1 && (
                    <>
                        <button
                            className="prev"
                            onClick={prevSlide}
                            aria-label="Ảnh trước"
                        >
                            ❮
                        </button>

                        <button
                            className="next"
                            onClick={nextSlide}
                            aria-label="Ảnh tiếp theo"
                        >
                            ❯
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}